module.exports = [
	{
		"name": "All funds"
	},
	{
		"name": "Aggressive Allocation"
	},
	{
		"name": "China Region"
	},
	{
		"name": "Commodities Focused"
	},
	{
		"name": "Communications"
	},
	{
		"name": "Conservative Allocation"
	},
	{
		"name": "Consumer Cyclical"
	},
	{
		"name": "Consumer Defensive"
	},
	{
		"name": "Derivative Income"
	},
	{
		"name": "Diversified Emerging Mkts"
	},
	{
		"name": "Diversified Pacific/Asia"
	},
	{
		"name": "Energy Limited Partnership"
	},
	{
		"name": "Equity Energy"
	},
	{
		"name": "Equity Hedged"
	},
	{
		"name": "Equity Market Neutral"
	},
	{
		"name": "Equity Precious Metals"
	},
	{
		"name": "Europe Stock"
	},
	{
		"name": "Financial"
	},
	{
		"name": "Foreign Large Blend"
	},
	{
		"name": "Foreign Large Growth"
	},
	{
		"name": "Foreign Large Value"
	},
	{
		"name": "Foreign Small/Mid Blend"
	},
	{
		"name": "Foreign Small/Mid Growth"
	},
	{
		"name": "Foreign Small/Mid Value"
	},
	{
		"name": "Global Allocation"
	},
	{
		"name": "Global Large-Stock Blend"
	},
	{
		"name": "Global Large-Stock Growth"
	},
	{
		"name": "Global Large-Stock Value"
	},
	{
		"name": "Global Real Estate"
	},
	{
		"name": "Global Small/Mid Stock"
	},
	{
		"name": "Health"
	},
	{
		"name": "India Equity"
	},
	{
		"name": "Industrials"
	},
	{
		"name": "Infrastructure"
	},
	{
		"name": "Japan Stock"
	},
	{
		"name": "Large Blend"
	},
	{
		"name": "Large Growth"
	},
	{
		"name": "Large Value"
	},
	{
		"name": "Latin America Stock"
	},
	{
		"name": "Long-Short Equity"
	},
	{
		"name": "Mid-Cap Blend"
	},
	{
		"name": "Mid-Cap Growth"
	},
	{
		"name": "Mid-Cap Value"
	},
	{
		"name": "Miscellaneous Region"
	},
	{
		"name": "Miscellaneous Sector"
	},
	{
		"name": "Moderate Allocation"
	},
	{
		"name": "Moderately Aggressive Allocation"
	},
	{
		"name": "Moderately Conservative Allocation"
	},
	{
		"name": "Natural Resources"
	},
	{
		"name": "Pacific/Asia ex-Japan Stk"
	},
	{
		"name": "Preferred Stock"
	},
	{
		"name": "Real Estate"
	},
	{
		"name": "Small Blend"
	},
	{
		"name": "Small Growth"
	},
	{
		"name": "Small Value"
	},
	{
		"name": "Tactical Allocation"
	},
	{
		"name": "Target-Date 2025"
	},
	{
		"name": "Target-Date 2030"
	},
	{
		"name": "Target-Date 2035"
	},
	{
		"name": "Target-Date 2040"
	},
	{
		"name": "Target-Date 2045"
	},
	{
		"name": "Target-Date 2050"
	},
	{
		"name": "Target-Date 2055"
	},
	{
		"name": "Target-Date 2060"
	},
	{
		"name": "Target-Date 2065+"
	},
	{
		"name": "Technology"
	},
	{
		"name": "Trading--Leveraged Equity"
	},
	{
		"name": "Utilities"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/FundCategoryAll.json
// module id = 930
// module chunks = 0